/**
 * Entity Version Constants
 *
 * This file imports version constants directly from the release config JSON (source of truth).
 * No generator needed - TypeScript can import JSON directly.
 *
 * Terminology (consistent across Flutter, Angular, Backend):
 * - entityVer: Per-document version (same as entitySetVersion after Jan 2026 reset)
 * - entitySetVersion: Set of all entityVer values for a release (e.g., 1)
 *
 * NOTE: Reset to version 1 as part of encryption removal (Jan 2026).
 * Fresh start - no legacy migration support needed.
 */

// Import release config directly from JSON (same pattern as translations.json, colors.json)
import * as releaseConfig from '@app/_datas/releaseConfig.json';

/**
 * The local release config JSON - source of truth
 */
export const LOCAL_RELEASE_CONFIG = releaseConfig;

/**
 * Current entity set version from release config.
 * Used for:
 * - Request-level entitySetVersion sent to backend (NUMBER, not string)
 */
export const ENTITY_SET_VERSION = releaseConfig.entitySetVersion;
